<template>
    <section v-if="hasPermissions(['Assignment-Project-Template Read','Assignment-Project-Template Write', 'Assignment-Project-Template Project-Template-Upload', 'Assignment-Project-Template Schedule-Rooms'])" class="view">
        <Breadcrumb :breadcrumb="breadcrumb"/>
        <h1 class="view__title title--1">
            {{ title_page }}
        </h1>
        <div class="view__description">
            <p class="view__description__text">
                This is a list of Project Assignments. Clicking the Detail icon allows you to modify the specifics of the Assignment. Clicking the Description link allows you to add and remove Rooms. To add a new Project Assignment, click "Add Project" and fill in the required fields, then click Save.
            </p>
        </div>

        <div class="bar-container">
            <div class="bar-container__search-bar">
                <div class="input-field my-0" v-if="projects.length && hasPermissions(['Assignment-Project-Template Read'])">
                    <i class="material-icons prefix iconInput">search</i>
                    <input id="icon_prefix" type="text" class="validate inputSearch" placeholder="Search" v-model="search">
                </div>
            </div>
            <div class="bar-container__options">
                <UploadOptions
                    :ref="'file_excel'"
                    :empty_format_data="empty_format_data"
                    :excel_file_headers="excel_file_headers"
                    :file_name="'projects_template_file'"
                    @data="upload($event)"
                    v-if="hasPermissions(['Assignment-Project-Template Project-Template-Upload'])"
                />
                <button v-if="hasPermissions(['Assignment-Project-Template Write'])" class="modal__buttons__item w-auto mr-md-auto ml-sm-2 px-3 ml-md-2" v-html="'Mass Delete'" :class="{'disabled button__disabled' : !selected}" :disabled="!selected" @click="massive_modal_delete()"/>
            </div>
            <div class="bar-container__cta">
                <span class="button__modal text-right">
                    <a v-if="hasPermissions(['Assignment-Project-Template Write'])" href="#" @click="form_modal()" class="d-inline-md-block">
                        {{ add_btn }}
                        <i class="prefix ml-1">
                            <img src="/assets/img/svg/add.svg" alt="date" style="width: 15px">
                        </i>
                    </a>
                </span>
            </div>
        </div>

        <div class="tab-content" v-show="projects.length  && hasPermissions(['Assignment-Project-Template Read'])">
            <div class="tab-pane fade active show" id="listation">
                <div class="row mb-0 no-gutters">
                    <div class="col-lg-12">
                        <v-card>
                            <DinamicTable
                                :headers="table_headers"
                                :items="projects"
                                :search="search"
                                :checkable="true"
                                :link="child_href"
                                :updateable="true"
                                @emitToUpdate="modal_update($event)"
                                name="project_template"
                            />
                        </v-card>
                    </div>
                </div>
            </div>
        </div>

         <ScheduledFormModal 
            :title="'New Scheduled Rooms'"
            :breadcrumb="breadcrumb"
            :rest_api="scheduled_rest_api"
            :notyf="notyf"
            :array_options="scheduled_array_options"
            :scheduled_current_date="scheduled_current_date"
            @RefreshHomeLocation="refresh_location($event)"
            ref="schedule_form_modal"
        />

        <DeletionModal 
            :single_object="single_object" 
            :global_index="global_index" 
            @objectDeletion="object_deletion($event)"
        />

        <DeletionMassiveModal
            @objectDeletion="massive_local_emition($event)"
        />

        <FormModal 
            :title="'New Project'"
            :breadcrumb="breadcrumb"
            :content_header="content_header"
            :rest_api="rest_api"
            :field="field"
            :notifications="notifications"
            :notyf="notyf"
            :axios="axios"
            :array_options="array_options"
            @unshiftObject="unshift_object($event)"
        />

        <UpdateModal 
            :title="'Project Update'"
            :breadcrumb="breadcrumb"
            :content_header="content_header"
            :rest_api="rest_api"
            :field="field"
            :notifications="notifications"
            :notyf="notyf"
            :axios="axios"
            :single_object="single_object"
            :global_index="global_index"
            :array_options="array_options"
            @spliceObject="splice_object($event)"
        />

        <WaitingModal/>

        <UploadSummary
            :breadcrumb="breadcrumb"
            :summary="summary"
            :excel_file_headers="excel_file_headers"
            :excel_data="excel_data"
            :file_name="'projects_falied_template_file'"
        />

        <HelperModal :helps="helps"/>

    </section>
    <div v-else>
        <UnauthorizedComponent :breadcrumb="breadcrumb"/>
    </div>
</template>

<script>

import axios                    from    'axios';
import Breadcrumb               from    '@/components/BreadcrumbComponent/Breadcrumb'
import WaitingModal             from    '@/components/WaitingModal'
import FormResources            from    './form_resources'
import Resources                from    './resources'
import FormModal                from    './FormModal'
import UpdateModal              from    './UpdateModal'
import DeletionModal            from    '@/components/DeletionModal'
import DeletionMassiveModal     from    '@/components/DeletionMassiveModal'
import DinamicTable             from    '@/components/DinamicTable'
import UploadOptions            from    '@/components/UploadOptions'
import UploadSummary            from    '@/components/UploadSummary'
import ScheduledFormModal       from    './ScheduledFormModal'
import UnauthorizedComponent from   '@/components/UnauthorizedComponent'
import HelperModal          from    '@/components/HelperModal'
import { Notyf }                from    'notyf';
import 'vuetify/dist/vuetify.min.css'
import 'notyf/notyf.min.css'; // for React and Vue
const notyf = new Notyf({
    duration: 8000,
});

export default {

    name:   'ProjectTemplate',

    components:{
        Breadcrumb,
        WaitingModal,
        FormModal,
        UpdateModal,
        DeletionModal,
        DeletionMassiveModal,
        DinamicTable,
        UploadOptions,
        UploadSummary,
        ScheduledFormModal,
        UnauthorizedComponent,
        HelperModal
    },

    data(){
        return{
            notyf,
            axios,
            child_href:             '/assignment-project/',
            user:                   this.get_user(),
            title_page:             'Projects',
            content_header:         this.$store.state.headers,
            rest_api:               `projects`,
            scheduled_rest_api:     `projects-schedulers`,
            notifications:          this.$store.state.form_notyf,
            table_headers:          Resources.table_headers,
            breadcrumb:             Resources.breadcrumb,
            field:                  FormResources.fields,
            shift_options:          FormResources.shift_options,
            add_btn:                'Add Project',
            single_select:          false,
            table_selection:        [],
            search:                 '',
            global_index:           0,
            single_object:          {},
            projects:               [],
            associates:             [],
            array_options:          {},
            select_ids:             [],
            excel_file_headers:     Resources.excel_file_headers,
            empty_format_data:      Resources.empty_format_data,
            excel_fields_required:  Resources.excel_fields_required,
            summary:                [],
            excel_data:             [],
            scheduled_array_options: {},
            scheduled_current_date: '',
            helps:              Resources.helps
        }
    },

    methods:{

        scheduled_form_modal()
        {
            window.$('#static-schedule-rooms').modal('show')
            this.$refs.schedule_form_modal.initialSetup()

        },
        format_boolean(value)
        {
            let boolean_string = ''
            value ? boolean_string = 'Yes' : boolean_string = 'No'
            return boolean_string
        },
        
        unshift_object(new_object)
        {
            this.projects.unshift(new_object)
        },

        splice_object(splicing_object)
        {
            this.projects.splice(splicing_object.index, 1, splicing_object.single_object)
        },

        form_modal()
        {
            if(!this.user.has_facility){
                notyf.error('There is not exists a facility yet')
                return false
            }
            window.$('#static').modal('show')
        },

        modal_deletion(index)
        {
            this.global_index  = index
            this.single_object = this.projects[index]
            window.$('#static-deletion').modal('show')
        },

        modal_update(index)
        {
            this.global_index  = index
            this.single_object = this.projects[index]
            window.$('#static-update').modal('show')
        },
        
        fill_data(data)
        {
            this.projects = data.projects
            this.array_options = {
                associate_id: data.associates,
                show_minutes: Resources.standard_options,
            }

            this.scheduled_current_date = data.current_date
            this.scheduled_array_options = {
                building_id:        data.buildings,
                task_id:            data.project_tasks,
                area_id:            [],
                level_id:           [],
            }
        },

        trashing(index)
        {
            this.projects.splice(index, 1)
        },

        massive_modal_delete()
        {
            this.select_ids = this.projects.filter(item => item.checked).map(item => item.id)
            if(this.select_ids.length)
            {
                window.$('#static-deletion-massive').modal('show')
            }
        },

        async massive_local_emition()
        {
            let json_request = {
                ids: this.select_ids,
            }

            let sendingMassive = await this.massive_delete(json_request)

            if(sendingMassive)
            {
                this.select_ids.forEach( item =>
                {
                    const index = this.projects.findIndex(value => value.id == item)
                    if(index > -1)
                    {
                        this.projects.splice(index, 1)
                    }
                })
                this.select_ids = []
            }
        },

        async upload(data)
        {
            const send_data = [];
            this.excel_data = []

            for ( const value of data ) {
                const entity = {}

                for (const prop in this.excel_file_headers) {
                    entity[this.excel_file_headers[prop]] = this.parse_boolean(value[prop])
                }

                this.excel_data.push({... entity})

                const show = this.array_options.show_minutes.find(item => item.name == entity.show_minutes)
                entity.show_minutes = show ? show.id : null

                const associate = this.array_options.associate_id.find(item => item.associate_name == entity.associate_id)        
                entity.associate_id = associate ? associate.id : undefined

                send_data.push(entity)
            }

            this.loader(true)
            const response = await this.post(`${this.rest_api}/massive`, { projects: send_data })
            this.loader()

            if(response.status)
            {
                notyf.success('Success!')
                this.summary = response.data.summary
                window.$('#upload-summary').modal('show')
                
                for (const project of response.data.projects) {
                    this.unshift_object(project);
                }
            }
            else
            {
                this.error_handling(response)
            }
            
            this.$refs.file_excel.clear_data()
        },

    },
    async mounted()
    {
        if( this.hasPermissions(['Assignment-Project-Template Read','Assignment-Project-Template Write', 'Assignment-Project-Template Project-Template-Upload', 'Assignment-Project-Template Schedule-Rooms']) )
        {
            await this.api_request()
        }
    },

    computed:
    {
        selected()
        {
            const bool = this.projects.filter(item => item.checked)
            return Boolean(bool.length)
        }
    }
}
</script>